import { Button, Select } from 'antd';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormEngine from "../../../src/DigitalForms/FormEngine";
import { checkIfObjectIsEmpty } from "../../../src/Helpers/Calculations";
import { pickAFileSliceDispatch } from "../../Constants/ReduxConstants";
import DigitalForm from "../../DigitalForms/DigitalForm";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import colorWheel from "../../Theme/ColorWheel";

const PreviewViewer = () => {
    const allQuestions = useSelector((state: any) => state.pickAFile.questions);
    const allBrands = useSelector((state: any) => state.pickAFile.brandList);
    const allServices = useSelector((state: any) => state.pickAFile.serviceList);
    const allRules = useSelector((state: any) => state.pickAFile.rules);
    const allActions = useSelector((state: any) => state.pickAFile.actions);

    const currentAutoFill = useSelector((state: any) => state.pickAFile.autoFill);
    const currentAnswers = useSelector((state: any) => state.pickAFile.answers);
    const currentMeta = useSelector((state: any) => state.pickAFile.meta);
    const currentDetails = useSelector((state: any) => state.pickAFile.details);

    const currentBrand = useSelector((state: any) => state.pickAFile.selectedBrandList);
    const currentService = useSelector((state: any) => state.pickAFile.selectedServiceList);

    const serviceDropDownList = useSelector((state: any) => state.pickAFile.serviceDropDownList);
    const brandDropDownList = useSelector((state: any) => state.pickAFile.brandDropDownList);

    const hasMultipleBrands = useSelector((state: any) => state.pickAFile.hasMultipleBrands);
    const hasMultipleServices = useSelector((state: any) => state.pickAFile.hasMultipleServices);

    const dispatch = useDispatch()

    const { filterQuestions } = ReduxHelpers();

    const sortedBrandDropDownList = useMemo(() =>
        [...(brandDropDownList ?? [])].sort((a: any, b: any) =>
            (a.label ?? '').toString().localeCompare((b.label ?? '').toString())
        ), [brandDropDownList]);

    const onBrandChange = (value) => {
        dispatch({ type: pickAFileSliceDispatch.setSelectedBrandList, payload: [value] })
    }

    const onServiceChange = (value) => {
        dispatch({ type: pickAFileSliceDispatch.setSelectedServiceList, payload: [value] })
    }

    const onOpenPreview = () => {
        let { filteredLayout, questionsToUse } = filterQuestions(currentBrand, currentService, allQuestions)

        const selectedBrandId = Array.isArray(currentBrand) ? currentBrand[0] : currentBrand;
        const brandEntry = allBrands?.find(b => b.brandId == selectedBrandId);
        const metaBase = Array.isArray(currentMeta) ? {} : (currentMeta ?? {});
        const metaForPreview = { ...metaBase, ...(brandEntry?.brandName ? { brandName: brandEntry.brandName } : {}) };

        const ctx = new FormEngine(
            questionsToUse,
            filteredLayout,
            allRules,
            allActions,
            currentAutoFill,
            checkIfObjectIsEmpty(currentAnswers) ? currentAutoFill : [],
            metaForPreview,
            {},
            {},
            currentDetails,
            {}
        );

        dispatch({ type: pickAFileSliceDispatch.setFormContext, payload: ctx })
    }

    const labelStyle: React.CSSProperties = {
        color: colorWheel.textGrey,
        fontSize: '12px',
        fontWeight: 500,
        marginBottom: '4px',
    };

    const fieldStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
    };

    const preview =
        <div>
            {(hasMultipleServices || hasMultipleBrands) && (
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: '16px', flexWrap: 'wrap', marginBottom: '1rem' }}>
                    {(allBrands?.length > 0 && hasMultipleBrands) && (
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Brand</label>
                            <Select
                                id="brandKey"
                                defaultValue={currentBrand}
                                placeholder="Select Brand"
                                options={sortedBrandDropDownList}
                                onChange={onBrandChange}
                                showSearch
                                filterOption={(input, option: any) =>
                                    (option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
                                }
                                style={{ minWidth: 200 }}
                            />
                        </div>
                    )}
                    {(allServices?.length > 0 && hasMultipleServices) && (
                        <div style={fieldStyle}>
                            <label style={labelStyle}>Service</label>
                            <Select
                                id="serviceKey"
                                placeholder="Select Service"
                                defaultValue={currentService}
                                options={serviceDropDownList}
                                onChange={onServiceChange}
                                style={{ minWidth: 200 }}
                            />
                        </div>
                    )}
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                        <Button onClick={onOpenPreview}>Open Preview</Button>
                    </div>
                </div>
            )}
            {(
                (hasMultipleBrands && currentBrand) ||
                ((!currentBrand || currentBrand?.length == 0) && currentService?.length > 0) ||
                ((!currentService || currentService?.length == 0) && (!currentBrand || currentBrand?.length == 0) && !hasMultipleServices && !hasMultipleBrands)
            ) && <DigitalForm canSubmit={false} onSubmitForm={() => {}} />}
        </div>
    return <div className="preview-viewer-content">{preview}</div>
}

export default PreviewViewer;
